var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 285,
    viewBox: "0 0 309 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.211 154.102C308.211 164.515 307.346 174.928 305.163 184.914L257.859 219.199L250.477 276.917H172.371L168.037 280.385C164.124 283.427 159.373 284.73 154.595 284.73C149.816 284.73 145.066 282.992 141.148 280.385L136.818 276.917H58.7084L51.7467 219.199L4.02976 184.914C1.84688 174.932 0.981567 164.518 0.981567 154.102C0.981567 69.0434 69.9754 0.474121 154.602 0.474121C239.228 0.474121 308.222 69.4744 308.222 154.102H308.211Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.935 152.359C284.935 161.195 284.201 170.03 282.348 178.503L242.213 207.592L235.949 256.564H169.678L166.001 259.507C162.681 262.088 158.65 263.194 154.596 263.194C150.541 263.194 146.511 261.719 143.187 259.507L139.513 256.564H73.2392L67.3324 207.592L26.846 178.503C24.9939 170.033 24.2597 161.198 24.2597 152.359C24.2597 80.1901 82.7988 22.0112 154.602 22.0112C226.405 22.0112 284.944 80.5558 284.944 152.359H284.935Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.816 150.854C264.816 158.325 264.195 165.796 262.628 172.961L228.688 197.56L223.392 238.972H167.351L164.242 241.461C161.434 243.643 158.025 244.579 154.597 244.579C151.168 244.579 147.76 243.332 144.949 241.461L141.842 238.972H85.7991L80.8041 197.56L46.5675 172.961C45.0013 165.799 44.3805 158.328 44.3805 150.854C44.3805 89.825 93.883 40.627 154.602 40.627C215.321 40.627 264.823 90.1342 264.823 150.854H264.816Z",
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.327 149.095C241.327 154.974 240.838 160.853 239.606 166.491L212.899 185.847L208.731 218.434H164.634L162.187 220.392C159.978 222.109 157.296 222.845 154.598 222.845C151.9 222.845 149.218 221.864 147.006 220.392L144.562 218.434H100.462L96.5317 185.847L69.5916 166.491C68.3591 160.855 67.8706 154.976 67.8706 149.095C67.8706 101.073 106.823 62.3596 154.602 62.3596C202.38 62.3596 241.333 101.316 241.333 149.095H241.327Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.438 147.607C221.438 152.138 221.06 156.668 220.112 161.013L199.531 175.929L196.319 201.04H162.336L160.45 202.548C158.748 203.87 156.68 204.439 154.6 204.439C152.519 204.439 150.454 203.683 148.75 202.548L146.866 201.04H112.882L109.852 175.929L89.0913 161.013C88.141 156.67 87.7651 152.138 87.7651 147.607C87.7651 110.6 117.784 80.7663 154.602 80.7663C191.419 80.7663 221.438 110.788 221.438 147.607Z",
    fill: "#FFC600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.9e55d59d5756336c53b2ec2b62ccad30.svg";
export { ForwardRef as ReactComponent };